import { createForm } from '@seek/forms-ui';
import { Box, Stack } from 'braid-design-system';
import React, { useState } from 'react';

import type { Language } from '../../../../../../shared/types';
import Form from '../Form/Form';
import IntroForm from '../IntroForm/IntroForm';

import ThankYou from './ThankYou';

const FORM_NAME = 'company-profiles-enquiry-form';

export interface FormValues {
  name: string;
  email: string;
  companyName: string;
  accountNumber: string;
}

const { FormProvider, useField } = createForm<FormValues, any, Language>(
  FORM_NAME,
);
export { useField };
const CompanyProfilesEnquiryForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const initialValues = {
    name: '',
    email: '',
    companyName: '',
    accountNumber: '',
  };
  return (
    <>
      {submitted ? (
        <ThankYou setSubmitted={setSubmitted} />
      ) : (
        <Box>
          <Stack space="large">
            <IntroForm />
            <FormProvider initialValues={initialValues}>
              {({ handleSubmit, resetForm, setFieldValue }) => (
                <Form
                  handleSubmit={handleSubmit}
                  setSubmitted={setSubmitted}
                  setFieldValue={setFieldValue}
                  resetForm={resetForm}
                />
              )}
            </FormProvider>
          </Stack>
        </Box>
      )}
    </>
  );
};

export default CompanyProfilesEnquiryForm;
